import { Mail, Phone, Link2 } from 'lucide-react';
import type { ShareContactCardProvider } from './shareContactCardProvider';

/**
 * What the recipient is about to receive, shown back to the sender.
 *
 * The card is not editable — it is a snapshot of the provider's public profile —
 * so this exists to make the send reviewable: the sender can see the phone and
 * email that are about to leave the platform before they commit to an address.
 */
export function ContactCardPreview({ provider }: { provider: ShareContactCardProvider }) {
  const subtitle = [provider.professionalTitle, provider.companyName].filter(Boolean).join(' · ');

  return (
    <div className="min-w-0 max-w-full overflow-hidden rounded-lg border bg-background p-4">
      <div className="flex min-w-0 items-start gap-3">
        {provider.profilePhoto ? (
          <img
            src={provider.profilePhoto}
            alt=""
            loading="lazy"
            className="h-12 w-12 shrink-0 rounded-full bg-gray-50 object-cover"
          />
        ) : (
          <div
            aria-hidden="true"
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#026857]/10 text-sm font-medium text-[#026857]"
          >
            {provider.displayName.slice(0, 1).toUpperCase()}
          </div>
        )}
        <div className="min-w-0 flex-1 overflow-hidden">
          <p className="truncate font-medium">{provider.displayName}</p>
          {subtitle && <p className="truncate text-sm text-gray-600">{subtitle}</p>}
          <div className="mt-2 space-y-1 text-sm text-gray-600">
            {provider.phoneNumber && (
              <p className="flex min-w-0 items-center gap-2">
                <Phone className="h-3.5 w-3.5 shrink-0 text-[#026857]" aria-hidden="true" />
                <span className="truncate">{provider.phoneNumber}</span>
              </p>
            )}
            {provider.email && (
              <p className="flex min-w-0 items-center gap-2">
                <Mail className="h-3.5 w-3.5 shrink-0 text-[#026857]" aria-hidden="true" />
                <span className="truncate">{provider.email}</span>
              </p>
            )}
            <p className="flex min-w-0 items-center gap-2">
              <Link2 className="h-3.5 w-3.5 shrink-0 text-[#026857]" aria-hidden="true" />
              <span className="truncate">Link to their bQuest profile</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
